<template>
  <b-alert
    :show="show"
    variant="danger"
    class="error-messages-alert"
    :dismissible="dismissible"
    @dismissed="dismissed"
  >
    <p v-for="(err, i) in messages" :key="i">
      <b-icon
        icon="exclamation-circle-fill"
        class="ml-2"
        font-scale="0.5"
        variant="warning"
      ></b-icon>
      {{ err }}
    </p>
  </b-alert>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      require: true,
      default: true
    },
    messages: {
      type: Array,
      required: true
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dismissed: function() {
      this.$emit("dismissed");
    }
  }
};
</script>

<style lang="scss">
.error-messages-alert {
  width: 100%;

  p:last-child {
    margin: 0;
  }
}
</style>
